import React from 'react';
import Card from '../components/ui/Card';

const AboutPage = () => {
  const values = [
    {
      title: "Innovation",
      description: "We constantly explore new technologies and approaches to deliver cutting-edge solutions."
    },
    {
      title: "Quality",
      description: "We never compromise on quality and always strive for excellence in everything we do."
    },
    {
      title: "Collaboration",
      description: "We work closely with our clients to understand their needs and deliver personalized solutions."
    },
    {
      title: "Transparency",
      description: "We believe in open communication and keeping our clients informed throughout the process."
    }
  ];

  return (
    <div className="min-h-screen py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            About Us
          </h1>
          <p className="text-xl text-gray-600">
            Learn more about our story, mission, and the team behind YourBrand.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
            <p className="text-gray-600 mb-4">
              Founded in 2020, YourBrand has been at the forefront of digital innovation, 
              helping businesses transform their online presence and reach their full potential.
            </p>
            <p className="text-gray-600 mb-4">
              Our team of experienced developers, designers, and strategists work together 
              to create solutions that not only look great but also deliver real results 
              for our clients.
            </p>
            <p className="text-gray-600">
              We believe in the power of technology to solve real-world problems and 
              create meaningful connections between businesses and their customers.
            </p>
          </div>
          <div className="bg-gradient-to-r from-blue-400 to-purple-500 rounded-lg h-64 flex items-center justify-center">
            <div className="text-white text-center">
              <h3 className="text-2xl font-bold mb-2">Our Mission</h3>
              <p className="text-lg">Empowering businesses through technology</p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 rounded-lg p-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {values.map((value, index) => (
              <Card key={index} className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;